import React from "react";
import { styled } from '@mui/material/styles';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import "./style.css";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width: '40%', // Set width to 80% of the screen
        maxWidth: 'none', // Remove the default maxWidth constraint
        minHeight: '250px'
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const InnoflexSaveModal: React.FC = (props) => {
    // @ts-ignore
    let open = props.open
    const handleClose = () => {
        //setOpen(false);
    };


    return (
        <>

            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <IconButton
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                </IconButton>
                <DialogContent dividers>
                    <div className="thank-card-wapper">
                        <h2 className="title-thank">Thank you for your survey feedback</h2>
                        <p className="sub-txt-disc">Submitting a while...</p>
                        <div className="loader-circle">
                            <span style={{background:"#97D700"}}></span>
                            <span style={{background:"#147BD1"}}></span>
                            <span style={{background:"#464E7E"}}></span>
                            <span style={{background:"#2DCCD3"}}></span>
                        </div>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>

    );
};

export default InnoflexSaveModal;
